import React from 'react';
import { Modal, Row, Col } from 'antd';

class ScreenStreamingPopup extends React.Component {
    state = {
        previewVisible: false,
        streamData: null
    };

    constructor(props) {
        super(props);
        this.videoRef = React.createRef();
    }

    streamScreen = (stream) => {
        this.showPreviewMedia(stream)

        var video = document.getElementById('screen_streaming')
        if ('srcObject' in video) {
            video.srcObject = stream
        } else {
            video.src = window.URL.createObjectURL(stream) // for older browsers
        }

        video.play()
    }


    showPreviewMedia = (stream = null, doShow = true) => {
        return new Promise((resolve, reject) => {
            this.setState({ streamData: stream, previewVisible: doShow }, () => { resolve() });
        })
    }

    clostPreview = () => {
        this.showPreviewMedia(null, false);
    }

    render() {

        return (

            <Modal
                className="dark-modal"
                title=""
                centered
                open={this.state.previewVisible}
                footer={null}
                onOk={() => this.clostPreview()}
                onCancel={() => this.clostPreview()}
                wrapClassName="modal-window"
                width={800}
            >
                <Row justify="space-around" align="middle" >
                    <Col style={{ width: "700px", height: "500px" }}>
                        <div style={{ width: '100%', height: '100%' }}>
                            <video type="video/mp4" controls={false} key={"screen_streaming"} ref={this.videoRef} id={"screen_streaming"} autoPlay={true} style={{ width: '100%', height: '100%', objectFit: "contain" }}>
                                <source src="" codecs="avc1.4D401E, mp4a.40.2" />
                            </video>
                        </div>
                    </Col>
                </Row>
            </Modal>
        )
    }
}

export default ScreenStreamingPopup